<app-page-header
  theme="light"
  [title]="'insurance.title' | translate"
>
  <div description>
    <span>{{ 'insurance.subtitle' | translate }}.</span>
  </div>
</app-page-header>

<div class="mobile:px-5 px-10 bg-gray-100">
  <div class="pt-6 pb-3 text-justify border-b">
    <h6 class="m-1 font-bold">{{ 'insurance.section1.ask' | translate }}</h6>
    <p>
      <span>{{ 'insurance.section1.description1' | translate }}</span>
      <span> {{ 'product.caserUnitLinked' | translate }} </span>
      <span [innerHTML]="'insurance.section1.description2' | translate"></span>
      <span> {{ 'shared.partners.caserInsurance' | translate }} </span>
      <span>{{ 'insurance.section1.description3' | translate }}:</span>
    </p>
  </div>

  <div class="py-3 text-justify border-b">
    <h6 class="m-1 font-bold">{{ 'insurance.section2.ask' | translate }}</h6>
    <p>
      <span>{{ 'insurance.section2.description' | translate }}:</span>
    </p>
    <ul class="ml-6 mb-4 list-disc">
      <li><span>{{ 'insurance.section2.list1' | translate }}.</span></li>
      <li><span>{{ 'insurance.section2.list2' | translate }}.</span></li>
      <li><span>{{ 'insurance.section2.list3' | translate }}.</span></li>
      <li><span>{{ 'insurance.section2.list4' | translate }}.</span></li>
      <li><span>{{ 'insurance.section2.list5' | translate }}.</span></li>
    </ul>
    <app-link (click)="goToAdvantagesUrl()" color="primary">{{ 'insurance.section2.link' | translate }}</app-link>
  </div>

  <div class="py-3 text-justify border-b">
    <h6 class="m-1 font-bold">{{ 'insurance.section3.ask' | translate }}</h6>
    <p>
      <span>{{ 'insurance.section3.description3' | translate }}.</span>
    </p>
  </div>

  <div class="py-3 text-justify border-b">
    <h6 class="m-1 font-bold">{{ 'insurance.section4.ask' | translate }}</h6>
    <p>{{ 'insurance.section4.description1' | translate }}.</p><br>
    <p>
      <span>{{ 'insurance.section4.description2' | translate }} </span>
      <app-link (click)="getInsuranceFaqUrl()" color="primary">{{ 'insurance.section4.link' | translate }}.</app-link>
    </p>
  </div>

  <div class="py-3 text-justify border-b">
    <h6 class="m-1 font-bold">{{ 'insurance.section5.ask' | translate }}</h6>
    <p>
      <span>{{ 'insurance.section5.description' | translate }}.</span>
    </p>
  </div>

  <div class="flex flex-col">
    <div class="py-10">
      <app-link (click)="goBack()" color="primary"><ion-icon name="arrow-back"></ion-icon> {{ 'shared.return'| translate }}</app-link>
    </div>
  </div>
</div>
